import React, { useRef, useEffect, useMemo, useState, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";

import TextQuestion from "../../components/questions/textQuestion/textQuestion";
import DropdownQuestion from "../../components/questions/dropdownQuestion/dropdownQuestion";
import DropdownWithOther from "../../components/questions/dropdownWithOther/dropdownWithOther";
import ABQuestion from "../../components/questions/abQuestion/abQuestion";
import MultipleChoiceQuestion from "../../components/questions/multipleChoiceQuestion/multipleChoiceQuestion";
import SingleSelectWithFollowUp from "../../components/questions/singleSelectWithFollowUp/singleSelectWithFollowUp";
import RatingQuestion from "../../components/questions/ratingQuestion/ratingQuestion";

import questionnaireScopeApi from "../../api/questionnaireScopeApi";
import usersApi from "../../api/usersApi";
import responsesApi from "../../api/responsesApi";

import mexicoStates from "../../data/mexicoStates";
import jobArea from "../../data/jobArea";
import ageRanges from "../../data/ageRanges";
import maritalStatus from "../../data/maritalStatus";
import commuteTime from "../../data/commuteTime";
import workScheme from "../../data/workScheme";
import workTimeType from "../../data/workTimeType";
import workHours from "../../data/workHours";
import diseases from "../../data/diseases";
import familyDiseases from "../../data/familyDiseases";
import waterIntake from "../../data/waterIntake";
import sleepHours from "../../data/sleepHours";
import exerciseLocation from "../../data/exerciseLocation";
import exerciseHours from "../../data/exerciseHours";
import eatingOut from "../../data/eatingOut";
import junkFood from "../../data/junkFood";
import fruitsVegetables from "../../data/fruitsVegetables";
import cigarettesPerWeek from "../../data/cigarettesPerWeek";
import alcoholFrequency from "../../data/alcoholFrequency";
import addictions from "../../data/addictions";
import emotionalWellbeingHours from "../../data/emotionalWellbeingHours";
import frequencyOptions from "../../data/frequencyOptions";
import frequencyFinancialStress from "../../data/frequencyFinancialStress";
import frequencyFriends from "../../data/frequencyFriends";
import frequencySocial from "../../data/frequencySocial";
import healthAutoEvaluation from "../../data/healthAutoEvaluation";
import healthChangesInteres from "../../data/healthChangesInteres";
import healtCheck from "../../data/healtCheck";

import "../../styles/hra.css";

const PAGE_SIZE = 5;

const sharedQuestions = (jobAreaOptions) => [
  {
    section: "shared",
    Component: TextQuestion,
    question: "¿Cuál es tu correo electrónico?",
    field: "email",
    type: "email"
  },
  {
    section: "shared",
    Component: DropdownQuestion,
    question: "¿Cuál es tu área de trabajo?",
    options: jobAreaOptions,
    field: "jobArea"
  },
  {
    section: "shared",
    Component: ABQuestion,
    question: "¿Cuál es tu sexo biológico?",
    optionA: "Masculino",
    optionB: "Femenino",
    field: "biologicalSex"
  },
  {
    section: "shared",
    Component: DropdownQuestion,
    question: "¿Cuál es tu rango de edad?",
    options: ageRanges,
    field: "ageRange"
  }
];

const hraQuestions = [
  { section: "hra", Component: DropdownQuestion, question: "¿En qué estado de la República vives?", options: mexicoStates, field: "residenceState" },
  { section: "hra", Component: TextQuestion, question: "¿Cuál es tu altura en centímetros? (Ejemplo: 160)", field: "height", type: "height" },
  { section: "hra", Component: TextQuestion, question: "¿Cuál es tu peso actual en kilogramos? (Ejemplo: 50)", field: "weight", type: "weight" },
  { section: "hra", Component: ABQuestion, question: "¿Has mantenido un peso similar en los últimos 6 meses? (+/- 2 kilos)?", optionA: "Sí", optionB: "No", field: "keepWeight" },
  { section: "hra", Component: DropdownQuestion, question: "¿Cuál es tu estado civil?", options: maritalStatus, field: "maritalStatus" },
  { section: "hra", Component: ABQuestion, question: "¿Tienes hijos?", optionA: "Sí", optionB: "No", field: "hasChildren" },
  { section: "hra", Component: DropdownQuestion, question: "¿Cuánto tiempo haces de trayecto al trabajo?", options: commuteTime, field: "commuteTime" },
  { section: "hra", Component: DropdownQuestion, question: "¿Cuál es tu esquema de trabajo?", options: workScheme, field: "workScheme" },
  { section: "hra", Component: DropdownQuestion, question: "¿Cuál es tu tipo de jornada laboral?", options: workTimeType, field: "workType" },
  { section: "hra", Component: DropdownQuestion, question: "¿Cuántas horas trabajas a la semana?", options: workHours, field: "workHours" },
  { section: "hra", Component: ABQuestion, question: "¿Trabajas los fines de semana?", optionA: "Sí", optionB: "No", field: "worksWeekend" },
  { section: "hra", Component: MultipleChoiceQuestion, question: "¿Has padecido alguna de las siguientes enfermedades?", options: diseases, field: "diseases" },
  { section: "hra", Component: MultipleChoiceQuestion, question: "¿Tienes algún familiar cercano con alguno de los siguientes padecimientos?", options: familyDiseases, field: "familyDiseases" },
  { section: "hra", Component: DropdownQuestion, question: "¿Cuántos vasos de agua tomas al día?", options: waterIntake, field: "waterIntake" },
  { section: "hra", Component: DropdownQuestion, question: "¿Cuántas horas duermes al día?", options: sleepHours, field: "sleepHours" },
  { section: "hra", Component: ABQuestion, question: "¿Haces algún deporte o actividad física?", optionA: "Sí", optionB: "No", field: "physicalActivity" },
  { section: "hra", Component: DropdownWithOther, question: "¿En dónde haces ejercicio?", options: exerciseLocation, field: "exerciseLocation" },
  { section: "hra", Component: DropdownQuestion, question: "¿Cuántas horas a la semana haces ejercicio?", options: exerciseHours, field: "exerciseHours" },
  { section: "hra", Component: TextQuestion, question: "¿Cuántas horas CONTINUAS pasas sentado SIN LEVANTARTE en el trabajo?", field: "sitOnWork", type: "numeric" },
  { section: "hra", Component: TextQuestion, question: "¿Cuántas horas permaneces sentado de forma CONTINUA mientras comes o estás en el comedor?", field: "sitOnEat", type: "numeric" },
  { section: "hra", Component: TextQuestion, question: "¿Cuántas horas CONTINUAS pasas sentado SIN LEVANTARTE en el traslado?", field: "sitOnJourney", type: "numeric" },
  { section: "hra", Component: TextQuestion, question: "¿Cuántas horas CONTINUAS pasas sentado SIN LEVANTARTE en casa?", field: "sitOnHome", type: "numeric" },
  { section: "hra", Component: DropdownQuestion, question: "¿Cuántas frutas o verduras comes al día?", options: fruitsVegetables, field: "fruitsVegetables" },
  { section: "hra", Component: DropdownQuestion, question: "¿Cuántos días a la semana comes en restaurantes/fondas o pides comida?", options: eatingOut, field: "eatingOut" },
  { section: "hra", Component: DropdownQuestion, question: "¿Cuántos días a la semana tomas refresco, dulces, fritangas u otros productos chatarra?", options: junkFood, field: "junkFood" },
  {
    section: "hra",
    Component: SingleSelectWithFollowUp,
    question: "¿Fumas?",
    options: ["Sí", "No", "Dejé de fumar hace más de un año"],
    field: "smokes",
    followUp: {
      trigger: "Sí",
      question: "¿Cuántos cigarros a la semana fumas?",
      options: cigarettesPerWeek,
      field: "cigarettesPerWeek"
    }
  },
  {
    section: "hra",
    Component: SingleSelectWithFollowUp,
    question: "¿Consumes alcohol?",
    options: ["Sí", "No"],
    field: "alcoholConsumption",
    followUp: {
      trigger: "Sí",
      question: "¿Cuántas veces a la semana consumes alcohol?",
      options: alcoholFrequency,
      field: "alcoholFrequency"
    }
  },
  { section: "hra", Component: DropdownQuestion, question: "¿Tienes alguna otra adicción?", options: addictions, field: "addictions" },
  { section: "hra", Component: DropdownQuestion, question: "¿Cuántas horas a la semana le dedicas a tu bienestar emocional?", options: emotionalWellbeingHours, field: "emotionalWellbeingHours" },
  { section: "hra", Component: RatingQuestion, question: "Indica del 1 al 10 cuál consideras sea tu nivel de estrés.", maxRating: 10, field: "stressLevel" },
  { section: "hra", Component: DropdownQuestion, question: "¿Te sientes emocionalmente agotado?", options: frequencyOptions, field: "emotionalExhaustion" },
  { section: "hra", Component: DropdownQuestion, question: "¿Te sientes triste?", options: frequencyOptions, field: "sadness" },
  { section: "hra", Component: DropdownQuestion, question: "¿Te sientes frustrado?", options: frequencyOptions, field: "frustration" },
  { section: "hra", Component: RatingQuestion, question: "Indica del 1 al 10 qué tan realizado te sientes en tu trabajo.", maxRating: 10, field: "jobFulfillment" },
  { section: "hra", Component: RatingQuestion, question: "Indica del 1 al 10 qué tanto crees que tu empresa se preocupa por ti.", maxRating: 10, field: "companyCare" },
  { section: "hra", Component: RatingQuestion, question: "Indica del 1 al 10 qué tan feliz te sientes en tu vida.", maxRating: 10, field: "happiness" },
  { section: "hra", Component: DropdownQuestion, question: "En las últimas 4 semanas, ¿qué tan seguido has percibido estrés financiero?", options: frequencyFinancialStress, field: "frequencyFinancialStress" },
  { section: "hra", Component: DropdownQuestion, question: "¿Tienes contacto frecuente con amigos y familiares?", options: frequencyFriends, field: "frequencyFriends" },
  { section: "hra", Component: DropdownQuestion, question: "¿Participas en algún grupo o actividad social? (grupos de yoga, iglesia, voluntariado, talleres, actividades deportivas o culturales, asociaciones vecinales, etc.)", options: frequencySocial, field: "frequencySocial" },
  { section: "hra", Component: DropdownQuestion, question: "En general, ¿cómo consideras tu estado de salud?", options: healthAutoEvaluation, field: "healthAutoEvaluation" },
  { section: "hra", Component: DropdownQuestion, question: "¿Estás interesado en hacer un cambio en tus hábitos de salud y bienestar?", options: healthChangesInteres, field: "healthChangesInteres" },
  { section: "hra", Component: MultipleChoiceQuestion, question: "¿Te has realizado alguno de estos chequeos o medidas de prevención en los últimos 12 meses?", options: healtCheck, field: "healtCheck" }
];

const stressQuestions = [
  { section: "stress", outputField: "emotionalExhaustion", Component: RatingQuestion, question: "Me siento emocionalmente agotado por mi trabajo.", maxRating: 7, startsInCero: true, field: "stress_emotionalExhaustion" },
  { section: "stress", outputField: "endOfDayFatigue", Component: RatingQuestion, question: "Me siento acabado al final de la jornada.", maxRating: 7, startsInCero: true, field: "stress_endOfDayFatigue" },
  { section: "stress", outputField: "morningFatigue", Component: RatingQuestion, question: "Me siento fatigado al levantarme por la mañana y tener que enfrentarme a otro día de trabajo", maxRating: 7, startsInCero: true, field: "stress_morningFatigue" },
  { section: "stress", outputField: "dailyWorkStress", Component: RatingQuestion, question: "Trabajar todo el día realmente es estresante para mi", maxRating: 7, startsInCero: true, field: "stress_dailyWorkStress" },
  { section: "stress", outputField: "problemSolving", Component: RatingQuestion, question: "Soy capaz de resolver eficazmente los problemas que surgen en mi trabajo.", maxRating: 7, startsInCero: true, field: "stress_problemSolving" },
  { section: "stress", outputField: "burnoutFeeling", Component: RatingQuestion, question: "Me siento quemado o agotado por mi trabajo", maxRating: 7, startsInCero: true, field: "stress_burnoutFeeling" },
  { section: "stress", outputField: "workContribution", Component: RatingQuestion, question: "Siento que estoy haciendo una buena contribución a la actividad de mi centro laboral", maxRating: 7, startsInCero: true, field: "stress_workContribution" },
  { section: "stress", outputField: "lossOfInterest", Component: RatingQuestion, question: "Desde que empecé en este puesto, he ido perdiendo interés en mi trabajo", maxRating: 7, startsInCero: true, field: "stress_lossOfInterest" },
  { section: "stress", outputField: "lossOfEnthusiasm", Component: RatingQuestion, question: "He ido perdiendo el entusiasmo en mi trabajo", maxRating: 7, startsInCero: true, field: "stress_lossOfEnthusiasm" },
  { section: "stress", outputField: "selfEfficacy", Component: RatingQuestion, question: "En mi opinión, soy muy bueno haciendo mi trabajo", maxRating: 7, startsInCero: true, field: "stress_selfEfficacy" },
  { section: "stress", outputField: "jobFulfillment", Component: RatingQuestion, question: "Me siento realizado cuando logro algo en mi trabajo", maxRating: 7, startsInCero: true, field: "stress_jobFulfillment" },
  { section: "stress", outputField: "valuableAchievements", Component: RatingQuestion, question: "He realizado muchas cosas que valen la pena en mi trabajo", maxRating: 7, startsInCero: true, field: "stress_valuableAchievements" },
  { section: "stress", outputField: "cinicWork", Component: RatingQuestion, question: "Me he vuelto más cínico y pesimista en mi trabajo", maxRating: 7, startsInCero: true, field: "stress_cinicWork" },
  { section: "stress", outputField: "doubtWorkImportance", Component: RatingQuestion, question: "Dudo de la importancia de mi trabajo", maxRating: 7, startsInCero: true, field: "stress_doubtWorkImportance" },
  { section: "stress", outputField: "confidenceInEffectiveness", Component: RatingQuestion, question: "En mi trabajo estoy seguro de que soy eficaz haciendo las cosas.", maxRating: 7, startsInCero: true, field: "stress_confidenceInEffectiveness" },
  { section: "stress", outputField: "insomnia", Component: RatingQuestion, question: "Imposibilidad de conciliar el sueño.", maxRating: 7, startsInCero: true, field: "stress_insomnia" },
  { section: "stress", outputField: "headaches", Component: RatingQuestion, question: "Jaquecas y dolores de cabeza.", maxRating: 7, startsInCero: true, field: "stress_headaches" },
  { section: "stress", outputField: "gastrointestinalIssues", Component: RatingQuestion, question: "Indigestiones o molestias gastrointestinales", maxRating: 7, startsInCero: true, field: "stress_gastrointestinalIssues" },
  { section: "stress", outputField: "extremeTiredness", Component: RatingQuestion, question: "Sensación de cansancio extremo o agotamiento.", maxRating: 7, startsInCero: true, field: "stress_extremeTiredness" },
  { section: "stress", outputField: "increasedConsumption", Component: RatingQuestion, question: "Tendencia de comer, beber o fumar más de lo habitual.", maxRating: 7, startsInCero: true, field: "stress_increasedConsumption" },
  { section: "stress", outputField: "lowSexDrive", Component: RatingQuestion, question: "Disminución del interés sexual.", maxRating: 7, startsInCero: true, field: "stress_lowSexDrive" },
  { section: "stress", outputField: "shortnessOfBreath", Component: RatingQuestion, question: "Respiración entrecortada o sensación de ahogo.", maxRating: 7, startsInCero: true, field: "stress_shortnessOfBreath" },
  { section: "stress", outputField: "lossOfAppetite", Component: RatingQuestion, question: "Disminución del apetito.", maxRating: 7, startsInCero: true, field: "stress_lossOfAppetite" },
  { section: "stress", outputField: "muscleTremors", Component: RatingQuestion, question: "Temblores musculares (por ejemplo tics nerviosos o parpadeos).", maxRating: 7, startsInCero: true, field: "stress_muscleTremors" },
  { section: "stress", outputField: "bodyPains", Component: RatingQuestion, question: "Pinchazos o sensaciones dolorosas en distintas partes del cuerpo.", maxRating: 7, startsInCero: true, field: "stress_bodyPains" },
  { section: "stress", outputField: "morningAvoidance", Component: RatingQuestion, question: "Tentaciones fuertes de no levantarse por la mañana.", maxRating: 7, startsInCero: true, field: "stress_morningAvoidance" },
  { section: "stress", outputField: "sweatingPalpitations", Component: RatingQuestion, question: "Tendencias a sudar o palpitaciones.", maxRating: 7, startsInCero: true, field: "stress_sweatingPalpitations" }
];

const SECTION_COPY = {
  shared: {
    title: "Datos generales",
    text: "Primero responde tus datos base. Después inicia la sección HRA y al final la sección de Estrés/Burnout."
  },
  hra: {
    title: "Sección HRA",
    text: "Responde con sinceridad sobre hábitos, salud y bienestar para calcular tus indicadores de riesgo en salud."
  },
  stress: {
    title: "Sección Burnout",
    text: "Lee cuidadosamente cada enunciado y marca la frecuencia con la que te ha ocurrido en el trabajo."
  }
};

const isAnswerPresent = (question, value) => {
  if (value === undefined || value === null) return false;
  if (Array.isArray(value)) {
    if (!value[0]) return false;
    if (question.followUp && value[0] === question.followUp.trigger) {
      return Boolean(value[1]);
    }
    return true;
  }
  return value !== "";
};

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const DECIMAL_REGEX = /^[0-9]*\.?[0-9]*$/;
const INTEGER_REGEX = /^[0-9]+$/;

const getTextQuestionError = (question, rawValue) => {
  if (question.Component !== TextQuestion) return "";
  const value = typeof rawValue === "string" ? rawValue.trim() : "";
  if (!value) return "Este campo es obligatorio";

  switch (question.type) {
    case "email":
      return EMAIL_REGEX.test(value) ? "" : "Ingresa un correo electrónico válido";
    case "height": {
      const n = parseFloat(value);
      return DECIMAL_REGEX.test(value) && !Number.isNaN(n) && n >= 100 && n <= 240
        ? ""
        : "Altura debe estar entre 100 y 240 cm";
    }
    case "weight": {
      const n = parseFloat(value);
      return DECIMAL_REGEX.test(value) && !Number.isNaN(n) && n >= 30 && n <= 250
        ? ""
        : "Peso debe estar entre 30 y 250 kg";
    }
    case "numeric":
      return INTEGER_REGEX.test(value) ? "" : "Solo números enteros";
    default:
      return "";
  }
};

const getQuestionError = (question, value) => {
  if (!isAnswerPresent(question, value)) return "Pregunta obligatoria";
  return getTextQuestionError(question, value);
};

export const HEALTH_BURNOUT_TOTAL_QUESTIONS =
  sharedQuestions(jobArea).length + hraQuestions.length + stressQuestions.length;

const HealthBurnoutQuestionnaire = ({ totalQuestions = HEALTH_BURNOUT_TOTAL_QUESTIONS, updateProgress }) => {
  const { questionnaire, idEmpresa, applicationId } = useParams();
  const navigate = useNavigate();

  const [company, setCompany] = useState({ name: "" });
  const [companyJobAreas, setCompanyJobAreas] = useState([]);
  const [answers, setAnswers] = useState({});
  const [, setAnsweredState] = useState(new Array(totalQuestions).fill(false));
  const [currentPage, setCurrentPage] = useState(0);
  const [pendingFocusField, setPendingFocusField] = useState(null);
  const containerRef = useRef(null);
  const questionsRef = useRef([]);

  useEffect(() => {
    (async () => {
      try {
        const scopeResp = await questionnaireScopeApi.getById(idEmpresa);
        setCompany(scopeResp);
        setCompanyJobAreas(scopeResp.jobAreas || []);
      } catch (error) {
        console.error("Error cargando empresa/sucursal:", error);
      }
    })();
  }, [idEmpresa]);

  const allQuestions = useMemo(() => {
    const jobAreaOptions = companyJobAreas.length ? companyJobAreas : jobArea;
    return [
      ...sharedQuestions(jobAreaOptions),
      ...hraQuestions,
      ...stressQuestions
    ];
  }, [companyJobAreas]);

  useEffect(() => {
    questionsRef.current = questionsRef.current.slice(0, allQuestions.length);
  }, [allQuestions.length]);

  const filteredQuestions = useMemo(() => {
    if (answers.physicalActivity !== "No") {
      return allQuestions;
    }

    return allQuestions.filter(
      (q) => q.field !== "exerciseLocation" && q.field !== "exerciseHours"
    );
  }, [allQuestions, answers.physicalActivity]);

  useEffect(() => {
    const locIdx = allQuestions.findIndex((q) => q.field === "exerciseLocation");
    const hrsIdx = allQuestions.findIndex((q) => q.field === "exerciseHours");

    if (answers.physicalActivity === "No") {
      setAnswers((prev) => ({
        ...prev,
        exerciseLocation: "",
        exerciseHours: exerciseHours[0]
      }));
      setAnsweredState((prev) => {
        const next = [...prev];
        if (locIdx >= 0) next[locIdx] = true;
        if (hrsIdx >= 0) next[hrsIdx] = true;
        return next;
      });
    }
  }, [answers.physicalActivity, allQuestions]);

  const markQuestionAsAnswered = useCallback(
    (index, field, value) => {
      setAnswers((prev) => ({ ...prev, [field]: value ?? "" }));
      setAnsweredState((prev) => {
        const next = [...prev];
        const wasAnswered = next[index];
        next[index] = true;
        if (!wasAnswered && typeof updateProgress === "function") {
          updateProgress();
        }
        return next;
      });
    },
    [updateProgress]
  );

  const totalPages = Math.ceil(filteredQuestions.length / PAGE_SIZE);
  const start = currentPage * PAGE_SIZE;
  const pageQuestions = filteredQuestions.slice(start, start + PAGE_SIZE);
  const currentSection = pageQuestions[0]?.section || "shared";

  const focusQuestionByField = useCallback((field) => {
    const idx = allQuestions.findIndex((q) => q.field === field);
    if (idx < 0) return false;

    const questionCard = questionsRef.current[idx];
    if (!questionCard) return false;

    questionCard.scrollIntoView({ behavior: "smooth", block: "center" });

    const focusable = questionCard.querySelector(
      "input, select, textarea, button, [tabindex]:not([tabindex='-1'])"
    );

    const focusTarget = focusable || questionCard;
    requestAnimationFrame(() => {
      focusTarget.focus?.({ preventScroll: true });
    });

    return true;
  }, [allQuestions]);

  const getFirstInvalidQuestion = useCallback((questionsToCheck) => {
    return questionsToCheck.find((q) => Boolean(getQuestionError(q, answers[q.field])));
  }, [answers]);

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
      return;
    }
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [currentPage]);

  useEffect(() => {
    if (!pendingFocusField) return;
    if (focusQuestionByField(pendingFocusField)) {
      setPendingFocusField(null);
    }
  }, [pendingFocusField, currentPage, focusQuestionByField]);

  const handleNext = () => {
    const firstInvalid = getFirstInvalidQuestion(pageQuestions);
    if (firstInvalid) {
      focusQuestionByField(firstInvalid.field);
      return;
    }

    setCurrentPage((p) => Math.min(p + 1, totalPages - 1));
  };

  const handlePrev = () => {
    setCurrentPage((p) => Math.max(p - 1, 0));
  };

  const handleSend = async () => {
    const firstInvalid = getFirstInvalidQuestion(filteredQuestions);
    if (firstInvalid) {
      const targetIndex = filteredQuestions.findIndex((q) => q.field === firstInvalid.field);
      const targetPage = Math.floor(targetIndex / PAGE_SIZE);

      if (targetPage !== currentPage) {
        setPendingFocusField(firstInvalid.field);
        setCurrentPage(targetPage);
      } else {
        focusQuestionByField(firstInvalid.field);
      }
      return;
    }

    try {
      const userResp = await usersApi.createFreeUser({
        username: answers.email,
        password: "",
        role: "user",
        company: idEmpresa
      });

      const generals = {};
      const hraAnswers = {};
      const estresBurnoutAnswers = {};

      allQuestions.forEach((q) => {
        const value = answers[q.field];
        if (value === undefined) return;

        const outputField = q.outputField || q.field;

        if (q.section === "shared") {
          generals[outputField] = value;
          return;
        }

        if (q.section === "hra") {
          hraAnswers[outputField] = value;
          return;
        }

        estresBurnoutAnswers[outputField] = value;
      });

      const payload = {
        userId: userResp.user._id,
        companyId: idEmpresa,
        questionnaireName: questionnaire,
        answers: {
          generals,
          hra: hraAnswers,
          estresBurnout: estresBurnoutAnswers
        },
        timestamp: new Date().toISOString(),
        applicationId: applicationId || null,
      };

      const result = await responsesApi.createHBResponse(payload);
      navigate("/hb/results", { state: { response: result.response || result } });
    } catch (error) {
      const serverMsg = error.response?.data?.message;
      alert(serverMsg || "Error enviando los datos. Intenta de nuevo más tarde.");
      console.error("Error enviando HB:", error);
    }
  };

  const progressPct = Math.round(((currentPage + 1) / totalPages) * 100);

  return (
    <div ref={containerRef} className="questionnaire-container">
      <h2>Cuestionario HRA & Burnout</h2>
      <p>Empresa: {company.name}</p>

      <div className="question-card" style={{ marginBottom: "1rem" }}>
        <h3>{SECTION_COPY[currentSection].title}</h3>
        <p>{SECTION_COPY[currentSection].text}</p>
        {currentSection === "stress" && (
          <>
            <p>0 = Nunca / Ninguna vez</p>
            <p>6 = Siempre / Todos los días</p>
          </>
        )}
      </div>

      <div className="progress-fill" style={{ width: `${progressPct}%` }} />
      <p className="progress-text">Página {currentPage + 1} de {totalPages}</p>

      {pageQuestions.map((q, idx) => {
        const globalIdx = allQuestions.findIndex((question) => question.field === q.field);
        const QuestionComp = q.Component;

        return (
          <div
            key={q.field}
            ref={(el) => (questionsRef.current[globalIdx] = el)}
            className="question-card"
            tabIndex={-1}
          >
            <QuestionComp
              question={q.question}
              required
              type={q.type}
              options={q.options}
              optionA={q.optionA}
              optionB={q.optionB}
              followUp={q.followUp}
              maxRating={q.maxRating}
              startsInCero={q.startsInCero}
              hourRange={q.hourRange}
              uniqueChoice={q.uniqueChoice}
              value={answers[q.field] ?? (q.Component === SingleSelectWithFollowUp ? [] : "")}
              updateProgress={(val) => markQuestionAsAnswered(globalIdx, q.field, val)}
            />
          </div>
        );
      })}

      <div className="pagination">
        {currentPage > 0 && (
          <button onClick={handlePrev} className="page-button">
            Anterior
          </button>
        )}

        {currentPage < totalPages - 1 ? (
          <button onClick={handleNext} className="page-button">
            Siguiente
          </button>
        ) : (
          <button onClick={handleSend} className="page-button submit-button">
            Enviar
          </button>
        )}
      </div>
    </div>
  );
};

export default HealthBurnoutQuestionnaire;
